module.exports = {
  "cancel": "取消",
  "other": "其他",
  "error": {
    "deleted": {
      "fav": "收藏内容已被删除"
    },
    "badrequest": "参数异常",
    "forbidden": "无权访问",
    "unknown": "服务异常",
    "frequency": {
      "limit": "操作太频繁，请稍后再试"
    },
    "already": {
      "group": "分组已存在"
    },
    "notfound": {
      "fav": "收藏不存在"
    }
  },
  "del": "删除",
  "comfirmToDel": "确认删除",
  "title": "我的收藏",
  "Within7days": "7天内",
  "search": "搜索",
  "from": "来自",
  "all": "全部",
  "sure": "确认",
  "noSearchData": "搜索无结果",
  "loadError": "加载失败",
  "forward": "转发",
  "photo": "图片/视频",
  "IAnd": "我和",
  "notSuportView": "暂不支持查看此类型消息",
  "whoCollect": "的收藏",
  "shareFail": "分享失败",
  "charRecord": "的聊天记录",
  "emptyTxt": "没有收藏任何内容",
  "previewImgFail": "查看图片失败",
  "doc": "文件",
  "isdelete": "你确定删除吗？",
  "ltnr": "聊天内容"
}